import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
export interface RequestParams {
  /** 终端id */
  device_id: string
  /** 数据类型 1-上传 2-下载 */
  data_type?: number
  login_status:number|null|string
  /** 最大值 20，默认5 */
  limit?: number
}

export interface Data {
  /** 进程 */
  name: string
  /** 数量 */
  num: number
}

export interface ResponseData {
  /** top进程数据 */
  data: Data[]
}
export interface terminalStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

export interface TopTerminalList {
  /** 终端名称 */
  computer_name: string
  /** 所属部门 */
  department: string
  /** 总流量（上传+下载） 单位字节*/
  total_flow: number
}

export interface terminalStatResponseData {
  /** 终端流量使用TOP列表 */
  top_terminal_list: TopTerminalList[]
}
export interface terminalTrendStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 趋势粒度："hour"表示按小时，"day"表示按天（可选，默认"hour"） */
  granularity?: string
}

export interface terminalTrendStatResponseData {
  /** 上传流量趋势数据列表（数组元素与time_points一一对应） */
  upload_flow_list: string[]
  /** 下载流量趋势数据列表（数组元素与time_points一一对应） */
  download_flow_list: string[]
  /** 时间戳列表（单位：秒，与流量数据一一对应） */
  time_points: string[]
}
export interface terminalOverviewStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
}

export interface terminalOverviewStatResponseData {
  /** 今日上传流量总 */
  today_upload_flow: number
  /** 今日下载流量总和 */
  today_download_flow: number
  /** 生效流量策略数量 */
  active_policy_count: number
}
@Injectable()
export class FlowService {
  constructor(private http: Http) {}
  getSafeMonitorFlowStatTop(data: RequestParams) {
    return this.http.post<ResponseData>('/safemonitor/flow-stat/top', data)
  }
  getSafemonitorFlowTopTerminalStat (data: terminalStatRequestParams) {
    return this.http.post<terminalStatResponseData>('/safemonitor/flow-top-terminal-stat', data)
  }
  getSafemonitorFlowTrendStat (data: terminalTrendStatRequestParams) {
    return this.http.post<terminalTrendStatResponseData>('/safemonitor/flow-trend-stat', data)
  }
  getSafemonitorFlowOverviewStat (data: terminalOverviewStatRequestParams) {
    return this.http.post<terminalOverviewStatResponseData>('/safemonitor/flow-overview-stat', data)
  }
}
